import { CustomerQueryImport, CustomerListaCustomer, CustomerFileImport } from 'app/models/customer-query-import.model';
import { CustomerImportExcel, CustomerSetImport } from 'app/models/customer-set-import.model';
import { HttpClientService } from './../httpClient/httpclient.service';
import { AuthService } from '../user/auth.service';
import { MessageService } from 'primeng/api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ListMetadata } from 'app/models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CustomerSetImportService {

  cachedCustomerQueryImport: Observable<CustomerQueryImport>;
  userId: string;

  cachedCustomerSetImport: Observable<CustomerSetImport>;
  cachedCustomerSetImportExcel: Observable<CustomerImportExcel>;

  private baseUrl = 'koncentro-customers/customers/query-import';

  constructor(
    private http: HttpClientService,
      private authService: AuthService,
      private httpClient: HttpClient
  ) { }


  /**
  * Tramite GET carico i campi del dto di CustomerImportExcel in un Observable
  * @returns il dto CustomerImport
  */
   getCustomerSetImportFields() {
    if (!this.cachedCustomerSetImport) {
      this.cachedCustomerSetImport = this.http.get(`koncentro-customers/schema/v2.CustomerImportDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCustomerSetImport;
  }

  /**
  * Tramite GET carico i campi del dto di CustomerImportExcel in un Observable
  * @returns il dto CustomerImport
  */
  getCustomerSetImportExcelFields() {
    if (!this.cachedCustomerSetImportExcel) {
      this.cachedCustomerSetImportExcel = this.http.get(`koncentro-customers/schema/v2.CustomerImportExcelDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCustomerSetImportExcel;
  }

  /**
  * Tramite metodo GET, restituisce la lista delle Query importati.
  * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<CustomerSetImport>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl+`/getListImport?` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getImportDetails(importId) {
    return this.http.get(`${this.baseUrl}/getListImport?id=${importId}`);
  }

  /**
   * Chiamata POST per verificare la query importata dal customer
   */
   checkImportQuery(data: any) {
    return this.http.post(`${this.baseUrl}/checkImportFile`, data)
  }

  /**
   * Chiamata POST per importare una query per customer
   */
   importQuery(data: FormData) {
    return this.http.upload(`${this.baseUrl}/createCustomerCluster`, data);
  }


  /**
   * Chiamata DELETE che elimina logicamente una query importata
   */
  deleteQueryImport(importId) {
    return this.http.delete(`${this.baseUrl}/deleteQueryImport/${importId}`)
  }

  downloadExcel(filename: string): Observable<Blob> {
    const requestBody = {'filename': filename};
    const userCompany = this.authService.user.selectedCompany.toString();
    const token =  `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.httpClient.post(
      '/koncentro-clustering/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-set-import.service.ts